export default __webpack_public_path__ + "static/media/ocbc.65151253.svg";